import i18n from 'modules/core/lib/i18n'

/**
 * Returns a human-readable message when the error indicates the uploaded file
 * is not a financial document (e.g. product photo). Reuse when showing OCR
 * errors for create-from-document and update-expensable-from-file flows.
 */
export const getOcrFriendlyErrorMessage = (message: string): string => {
  if (message.includes('non_document')) {
    return i18n.t('expenses_v2.modals.new_expense_ocr.error_not_financial_document')
  }
  return message
}

export const buildErrorMessages = (errors: Record<string, string>): string => {
  const errorsList = Object.entries(errors).reduce<Record<string, string[]>>(
    (acc, [key, message]) => {
      if (message !== undefined) {
        acc[key] = [message]
      }
      return acc
    },
    {}
  )

  const flatErrorListMessages = Object.values(errorsList).flat().join(', ')
  return flatErrorListMessages
}
